import React from 'react';

import "./GradientImg.scss";

export const GradientImg = ({ src, deg, col1, col2})=>{

    return (
        <div className="GradientImg" style={{ backgroundImage: `url(${src})` }}>
            <div id='grad' style={{ background: `linear-gradient(${deg}deg, ${col1} 0%, ${col2} 100%)` }}></div>
        </div>
    )
}

